export const RightNames = {
    CAN_READ_DATA: 'CAN_READ_DATA',
    CAN_MANAGE_DATAS: 'CAN_MANAGE_DATAS',
    CAN_WRITE_RIGHT: 'CAN_WRITE_RIGHT',
};
